'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var StrategyListingController = function StrategyListingController($scope, strategyConstants, dataRetrieverService, dataRetrieverConstants, saveStrategyService, $log) {
  var strategyDataRetrieve = dataRetrieverService.getDataRetriever(dataRetrieverConstants.STRATEGY_SCREEN, dataRetrieverConstants.STRATEGY_LISTING_MODE);
  $scope.PANEL_TYPE = strategyConstants.PANEL_TYPE;
  function setDataRetriever() {
    var mode = $scope.activeStrategyType === strategyConstants.PANEL_TYPE.OPTIMIZATION ? dataRetrieverConstants.STRATEGY_LISTING_MODE : dataRetrieverConstants.ALERT_STRATEGY_LISTING_MODE;
    strategyDataRetrieve = dataRetrieverService.getDataRetriever(dataRetrieverConstants.STRATEGY_SCREEN, mode);
  }
  $scope.$watch('activeStrategyType', function () {
    setDataRetriever();
  });
  function handleDuplicatingError(error) {
    var message = error.data && error.data.message || error.statusText || error.message;
    $log.error('StrategyListingController: handleDuplicatingError - ' + message);
    toastr.error(message);
  }
  function triggerDataChanged(data) {
    $scope.$emit('strategy:dataAndSelectionChanged', {
      name: data.name
    });
  }
  function retrieveStrategyRawData() {
    return strategyDataRetrieve.retrieveComponentData();
  }
  function findRawData(gridRow, rawDataSet) {
    return _.cloneDeep(_.find(rawDataSet, {
      name: gridRow.name
    }));
  }
  function duplicateStrategy(strategy) {
    return saveStrategyService.duplicateStrategy(strategy);
  }
  function handleDuplicateStrategy(event, strategyGridRow) {
    retrieveStrategyRawData().then(findRawData.bind(null, strategyGridRow)).then(duplicateStrategy).then(triggerDataChanged, handleDuplicatingError);
  }
  $scope.$on('strategy-listing:duplicateStrategy', handleDuplicateStrategy);
  $scope.$on('grid:beforeUpdateBoundData', function (evt, data) {
    _.each(data, function (strategy) {
      saveStrategyService.strategyRestrictedToString(strategy);
    });
  });
};
StrategyListingController.$inject = ['$scope', 'StrategyConstants', 'DataRetrieverService', 'DataRetrieverConstantsService', 'SaveStrategyService', '$log'];
module.exports = StrategyListingController;